import { useEffect, useState } from "react";
import { BrowserRouter, Routes } from "react-router-dom";
import { Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./App.css";
import Login from "./pages/login/Log-in";
import SginUp from "./pages/singUp/SginUp";
import PassRecover from "./pages/passRecover/PassRecover";
import Landing from "./pages/Landing/Landing"
import Header from "./components/header/Header";
import Main from "./pages/main/Main"
import MainResources from "./pages/mainResources/MainResources";
import MainStocks from "./pages/mainStocks/MainStocks";
import Assets from "./pages/assets/Assets";
import Kyc from "./pages/kycBlocks/kyc/Kyc";
import Policy from "./pages/policyBlocks/policy/Policy";
import PolicyAbout from "./pages/policyBlocks/policyAbout/PolicyAbout";
import PresonalInfo from "./pages/PersonalInfo/PresonalInfo";
import Transactions from "./pages/transactions/Transactions";
import WithdrawCrypto from "./pages/withdraw/withdrawCrypto/WithdrawCrypto";
import WithdrawBank from "./pages/withdraw/WithdrawBank/WithdrawBank";
import DepositCrypto from "./pages/Deposit/depositCrypto/DepositCrypto";
import DepostBank from "./pages/Deposit/depositBank/DepostBank";
import DepositApprove from "./pages/Deposit/depositApprove/DepositApprove";
import WithdrawApprove from "./pages/withdraw/WithdrawApprove/WithdrawApprove";
import Convert from "./pages/convertBlocks/convert/Convert";
import Transfer from "./pages/transfer/transfer/Transfer";
import PortfolioError from "./pages/portfolioBlocks/portfolioError/PortfolioError";
import Portfolio from "./pages/portfolioBlocks/portfolio/Portfolio";
import ExchangeClosed from "./pages/ExchangeClosed/ExchangeClosed";
import AccessDenied from "./pages/AccessDenied/AccessDenied";
import axios from "axios";
import Maintenance from "./pages/maintenance/Maintenance";

function App() {
    const {t, i18n} = useTranslation()
    const isAuth = localStorage.getItem("isLoggedIn")
    const token = localStorage.getItem("token")
    const [siteStatus, setSiteStatus] = useState(true)
    const [isNetworkError, setIsNetworkError] = useState(false)
    const [accesses, setAccesses] = useState({ //разрешение на
        withdraw:true,   // Вывод
        shares:true,     // Акции 
        spot_shares:true,// Все блоки Main
        portfolio:true,  // Портфолио
        orders:true      // Ордера
    })
    // axios.get("https://api-ru.fynex.cc/api/api/status")
    // .then((res)=>{
    //     res.data != true && setSiteStatus(false)
        
    // }).catch((res)=>{
    //     res.data != true && setSiteStatus(false)
    //     if(res?.message == "Network Error"){
    //         setIsNetworkError(true)
    //     }
    // })

    axios.get("https://api-ru.fynex.cc/api/api/status", { timeout: 4000 })
    .then((res) => {
        if(res.data !== true){
            setSiteStatus(false) // сервер ответил но сказал что сайт выключен
        }
    })
    .catch((error) => {
        if(error.message === "Network Error"){
            setIsNetworkError(true) // нет интернета
            return
        }else if (error.message == "timeout of 4000ms exceeded"){
            setIsNetworkError(true) // нет интернета
            return
        }
        // сервер не ответил или ошибка 500
        setSiteStatus(false)
    })
    useEffect(() => {
        if (!localStorage.getItem('language')) {
            const lng = navigator.language.toLowerCase()
            console.log(lng, "LANGUAGE CODE");
            if( lng.includes("ru") || lng.includes("ua") || lng.includes("be") || lng.includes("kk") || lng.includes("uz") || lng.includes("tg") || lng.includes("tk") || lng.includes("az")){
                localStorage.setItem('language', "ru")
            }else if( lng.includes("tr") ){
                localStorage.setItem('language', "tu")
            }else{
                localStorage.setItem('language', "en")
            }
            i18n.changeLanguage(localStorage.getItem('language'))
            window.location.reload()
        }
    }, [])

    useEffect(()=>{
        axios.get(`https://api-ru.fynex.cc/api/api/users/me`, {headers: {"Authorization" : `Bearer ${token}`}})
        .then(res => {
            setAccesses({
            withdraw: res.data.withdraw_allowed,
            shares: res.data.shares_allowed,
            spot_shares: res.data.spot_shares_allowed,
            portfolio: res.data.portfolio_available,
            orders: res.data.orders_allowed
            })
        })
    }, [])

    const MainBlocks = () => {
        const day = new Date().getDay();
        // let stoksResourseStatus = day == 0 || day == 6
        let stoksResourseStatus = false
        if(!accesses.orders) {
            return <Route path="/market" element={<AccessDenied text={t("BAN.allTrade")}/>} />
        }
        if(!accesses.spot_shares){
            return<>
                <Route path="/market" element={<AccessDenied text={t("BAN.allTrade")}/>} />
                <Route path="/market-resources" element={<AccessDenied text={t("BAN.allTrade")}/>} />
                <Route path="/market-stocks" element={<AccessDenied text={t("BAN.allTrade")}/>} />
            </>
        }
        if(!accesses.shares){
            if(stoksResourseStatus){
                return<>
                    <Route path="/market" element={<Main />} />
                    <Route path="/market-resources" element={<ExchangeClosed/>} />
                    <Route path="/market-stocks" element={<AccessDenied text={t("BAN.Stocks")}/>} />
                </>
            }
            else{
                return<>
                    <Route path="/market" element={<Main />} />
                    <Route path="/market-resources" element={<MainResources text={t("BAN.Resources")}/>} />
                    <Route path="/market-stocks" element={<AccessDenied text={t("BAN.Stocks")}/>} />
                </>
            }
        }
        if(stoksResourseStatus){
            return<>
                <Route path="/market" element={<Main />} />
                <Route path="/market-resources" element={<ExchangeClosed/>} />
                <Route path="/market-stocks" element={<ExchangeClosed/>} />
            </>
        }else{
            return<>
                <Route path="/market" element={<Main />} />
                <Route path="/market-resources" element={<MainResources/>} />
                <Route path="/market-stocks" element={<MainStocks/>} />
            </>
        }
    }

    const Withdraw = () => {
        if(!accesses.withdraw){
            return <>
                <Route path="/account/withdraw-crypto" element={<AccessDenied text={t("BAN.withdraw-crypto")} />} />
                <Route path="/account/withdraw" element={<AccessDenied text={t("BAN.withdraw")} />} />
                <Route path="/withdraw-approve" element={<AccessDenied text={t("BAN.withdraw-crypto")} />} />
            </>
        }else {
            return <>
                <Route path="/account/withdraw-crypto" element={<WithdrawCrypto />} />
                <Route path="/account/withdraw" element={<WithdrawBank />} />
                <Route path="/withdraw-approve" element={<WithdrawApprove />} />
            </>
        }
    }

    const PortfolioRoute = () => {
        if(!accesses.portfolio) {
            return <>
                <Route path="/portfolio-error" element={<PortfolioError/>} />
                <Route path="/account/portfolio" element={<PortfolioError/>} />
            </>
        }else {
            return <>
                <Route path="/portfolio-error" element={<PortfolioError/>} />
                <Route path="/account/portfolio" element={<Portfolio/>} />
            </>
        }

    }

    const Auth = () => {

        return <>
        <Route path="/*" element={<Landing />} />
        { MainBlocks() }
        <Route path="/account/" element={<Assets />} />
        <Route path="/account/me" element={<PresonalInfo />} />
        <Route path="/account/kyc" element={<Kyc />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/policy-about" element={<PolicyAbout />} />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/account/deposit-crypto" element={<DepositCrypto />} />
        <Route path="/account/deposit" element={<DepostBank />} />
        <Route path="/deposit-approve" element={<DepositApprove />} />
        { Withdraw() }
        { PortfolioRoute() }
        <Route path="/convert" element={<Convert />} />
        <Route path="/account/wallet" element={<Transfer />} />

        <Route path="/error/access-denied" element={<AccessDenied text={`${t("BAN.withdraw-crypto")}`}/>} />
        <Route path="/error/Maintenance" element={<Maintenance />} />
        </>
    }

    const NotAuth = () => <>
        <Route path="/*" element={<Landing />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/SignUp" element={<SginUp />} />
        <Route path="/recovery" element={<PassRecover />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/policy-about" element={<PolicyAbout />} />
    </>

    return (
        <BrowserRouter>
            <Routes>
                {isNetworkError ? (
                    <Route path="/*" element={<Maintenance isNetworkError={true} />} />
                ) : siteStatus === false ? (
                    <Route path="/*" element={<Maintenance />} />
                ) : (
                    isAuth === "true" ? Auth() : NotAuth()
                )}
            </Routes>
        </BrowserRouter>
    ); 

    // return (
    //     <BrowserRouter>
    //         <Routes>
    //             { 
    //                 siteStatus == true ?
    //                     isAuth === "true" ? Auth() : NotAuth()
    //                 :
    //                 isNetworkError ?
    //                 <Route path="/*" element={<Maintenance isNetworkError={true}/>} />
    //                 :
    //                 <Route path="/*" element={<Maintenance />} />
    //             }
    //         </Routes>
    //     </BrowserRouter>
    // );
}

export default App;
